<template>
  <SimpleLayout>
    <template #content>
      <div class="login-page">
        <div class="login-container">
          <router-link to="home">
            <img :src="logoImage" class="beepallet-logo" alt="Logo de BeePallet">
          </router-link>
          
          <form class="login-form" @submit.prevent="handleSubmit">
            <div class="input_container">
              <label class="input_label" for="username">E-mail</label>
              <input type="text" class="input-field is-placeholder" id="email" v-model="email" required />
            </div>
            <div class="input_container">
              <label class="input_label" for="password">Contraseña</label>
              <input type="password" id="password" class="input-field is-placeholder" v-model="password" required />
            </div>
            <button type="submit" class="btn-primary-m btn-primary-green">Conectarse</button>
            <router-link to="/auth/register" class="btn-secondary-black">
              ¿No tienes una cuenta? <span class="highlight">Regístrate</span>
            </router-link>

            <router-link :to="{name: 'forgot_password'}" class="btn-secondary-s btn-underline-black">He olvidado la contraseña</router-link>
          </form>
        </div>
        <LoadingComponent :overlay="true" :is-loading="isLoading"></LoadingComponent>
      </div>
    </template>
  </SimpleLayout>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import SimpleLayout from '@/layouts/simple/SimpleLayout.vue';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import logoImage from '@/assets/images/BeePallet_Logo_Black.png';
import {showErrorAlert, showExceptionAlert} from "@/helpers/SweetAlertHelper";
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import * as Session from "supertokens-web-js/recipe/session";
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import LoadingComponent from '@/components/common/LoadingComponent/LoadingComponent.vue';
import {initAppStore} from "@/store/init";
import { useStore } from 'vuex'

const store = useStore();
const email = ref('');
const password = ref('');
const router = useRouter();
const isLoading = ref<boolean>(false);
// const logoImageRef = logoImage;

const handleSubmit = async () => {
  try {
    isLoading.value = true;
    const response = await EmailPassword.signIn({
      formFields: [
        { id: "email", value: email.value },
        { id: "password", value: password.value },
      ],

    });

    if (response.status === "OK") {
      var isEmailVerified = await EmailVerification.isEmailVerified();

      if(!isEmailVerified.isVerified) {
        await EmailVerification.sendVerificationEmail();
        showErrorAlert("Por favor, verifica tu correo electrónico para continuar.");
        await Session.signOut();
        LocalStorageService.clearAll();
        return;
      }

      await initAppStore();

      const customerProfile = store.state.profile;

      (customerProfile?.name)?router.push({ name: "home" }):router.push({  name: "customer_profile" });

    } else {
      showErrorAlert("Email o contraseña invalidos");

    }
  } catch (error) {
    showExceptionAlert(error);
  }
  finally{
    isLoading.value = false;
  }
};
</script>

<style scoped lang="scss">
@import 'LoginPage';
</style>